import { render, staticRenderFns } from "./AddContactDialog.vue?vue&type=template&id=1bec0c0a"
import script from "./AddContactDialog.vue?vue&type=script&lang=ts"
export * from "./AddContactDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddContactDialog.vue?vue&type=style&index=0&id=1bec0c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports